import { MutableRefObject, useEffect, useState } from 'react';

export const useElementDimensions = (ref: MutableRefObject<HTMLElement>) => {
  const [elementDimensions, setElementDimensions] = useState<{
    width: number | undefined;
    height: number | undefined;
  }>({
    width: undefined,
    height: undefined,
  });

  const handleResize = (entries: ResizeObserverEntry[]) => {
    const dimensions = entries[0].contentRect;

    setElementDimensions({
      width: dimensions.width,
      height: dimensions.height,
    });
  };

  useEffect(() => {
    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return elementDimensions;
};
